import React, { useContext, useEffect, useState } from 'react'
import ContentSection from '../../Content';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../../../utils/User_check';
import DataTable from 'react-data-table-component';
import CustomerStyle from '../../../utils/customerStyle';
import BaseUrl from '../../../utils/BaseUrl';
import moment from 'moment';
import axios from 'axios';
import InfoDemandeAsset from './InfoDemandeAsset';


const url = BaseUrl();
const customerStyle = CustomerStyle();
const DemandeAssets = () => {
    const [itemsListFilter,setItemsListFilter] = useState([]);
    const [loading,setLoading] = useState(false);
    const [dataAssets,setDataAssets] = useState([]);
    const [stepNext,setStepNext] = useState(2);

    const {user,permissions} = useContext(UserContext);
    const navigate = useNavigate();



    const columns = [
        {
            name: 'DATE',
            selector: row => moment(row?.demande?.date).format('Do MMMM yy HH:mm'),
            sortable: true,
        },
        {
            name: 'REFERENCE',
            selector: row => row?.demande?.reference,
            sortable: true,
        },
        {
            name: 'PDV',
            selector: row => row?.demande?.d_pdv,
            sortable: true,
        },
        {
          name: "STATUT DEMANDE",
          selector : row => (
            <>
                {row?.demande?.status == 'En cours' && <span class="badge bg-warning">{row?.demande?.status}</span>}
                {row?.demande?.status == 'Validé' && <span class="badge bg-success">{row?.demande?.status}</span>}                                                        
                {row?.demande?.status == 'Réfusé' && <span class="badge bg-danger">{row?.demande?.status}</span>}    
            </>
          )
        },
        {
            name: 'AUT. PRECEDENTE',
            selector: row => (
               <>
                <b>{row.auteur.use_nom} {row.auteur.use_prenom}</b> (
                {row.status == 'En cours' && <span class="badge bg-warning">{row.status}</span>}
                {row.status == 'Validé' && <span class="badge bg-success">{row.status}</span>}                                                        
                {row.status == 'Réfusé' && <span class="badge bg-danger">{row.status}</span>})
               </> 
            ),
            sortable: true,
        },
         {
            name: 'AUT. SUIVANTE',
            selector: row => (
               <>
           
                {row.status_next == 'En cours' && <span class="badge bg-warning">{row.status_next}</span>}
                {row.status_next == 'Validé' && <span class="badge bg-success">{row.status_next}</span>}                                                        
                {row.status_next == 'Réfusé' && <span class="badge bg-danger">{row.status_next}</span>}
               </> 
            ),
            sortable: true,
        },
    ];

    useEffect(()=>{ 
        get_demande_assets_list();
    },[]);


    function get_demande_assets_list(next=2)
    {  setStepNext(next)
        setLoading(true);
        try {
            axios.get(url.base+'/list-demandesasset-bylevel?stepNext='+next,{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
                setLoading(false);
                setDataAssets(resp.data.data);
                setItemsListFilter(resp.data.data); 
            })
        } catch (error) {
            setLoading(false);
        }
    }

  const handleRowClicked = (row) => {
    navigate(`/approbation-demandes-assets/${row.demande.reference}`);
  };

  return (
        <ContentSection ulShownav={"gest-affectations"} navactive={"demandeasset"}>
                <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                
                                <div class="mb-5">
                                    <h3 class="mb-0 ">WorkFlow Demande</h3>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                        
                                <div class="card mb-4">
                                    <div class="card-header">
                                        <div class="row g-2">
                                            <div class="col-md-5 col-lg-3">
                                                {/* <input type="search" class="form-control w-100" placeholder="Recherche ..." /> */}
                                            </div>
                                            <div class="bg-info p-2">
                                                <button to="/materiel/files-import" class={stepNext==2? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list(2)}>CONFIRMATION TM { stepNext== 2 ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext==3? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list(3)}>APPROBATION ASM{ stepNext== 3 ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext==4? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list(4)}>APPROBATION RSM { stepNext== 4 ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext==5? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list(5)}>VALIDATION TMC { stepNext== 5 ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext==6? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list(6)}>EDITION DU CONTRAT{ stepNext== 6 ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext==7? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list(7)}>EMISSION DU CONTRAT{ stepNext== 7 ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext==8? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list(8)}>PREPARATION DE TOURNEE { stepNext== 8 ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext==9? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list(9)}>VALIDATION DE LA LIVRAISON { stepNext== 9 ? `(${dataAssets.length})` :""}</button>
                                                <button to="/materiel/files-import" class={stepNext==10? "btn btn-success mx-2" : "btn btn-grey mx-2"} onClick={()=>get_demande_assets_list(10)}>CLOTURE{ stepNext== 10 ? `(${dataAssets.length})` :""}</button>
                                            </div>
                                        
                                        
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="table-responsive table-card">
                                            <DataTable 
                                                columns={columns} 
                                                data={itemsListFilter}
                                                customStyles={customerStyle}
                                                pagination
                                                selectableRows
                                                progressPending={loading}
                                                onRowClicked={handleRowClicked}
                                                pointerOnHover
                                                highlightOnHover
                                                progressComponent={
                                                    <>
                                                    <div class="text-center">
                                                        <div class="spinner-border" role="status">
                                                        <span class="visually-hidden">Loading...</span>
                                                        </div>
                                                    </div>
                                                    </>
                                                } 
                                            />

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                </div>
        </ContentSection>
  )
}

export default DemandeAssets;